(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[335],{

/***/ 4044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTimeout; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _useMounted__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6454);
/* harmony import */ var _useWillUnmount__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6852);



/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */

var MAX_DELAY_MS = Math.pow(2, 31) - 1;

function setChainedTimeout(handleRef, fn, timeoutAtMs) {
  var delayMs = timeoutAtMs - Date.now();
  handleRef.current = delayMs <= MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(function () {
    return setChainedTimeout(handleRef, fn, timeoutAtMs);
  }, MAX_DELAY_MS);
}
/**
 * Returns a controller object for setting a timeout that is properly cleaned up
 * once the component unmounts. New timeouts cancel and replace existing ones.
 *
 *
 *
 * ```tsx
 * const { set, clear } = useTimeout();
 * const [hello, showHello] = useState(false);
 * //Display hello after 5 seconds
 * set(() => showHello(true), 5000);
 * return (
 *   <div className="App">
 *     {hello ? <h3>Hello</h3> : null}
 *   </div>
 * );
 * ```
 */


function useTimeout() {
  var isMounted = (0,_useMounted__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(); // types are confused between node and web here IDK

  var handleRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,_useWillUnmount__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function () {
    return clearTimeout(handleRef.current);
  });
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var clear = function clear() {
      return clearTimeout(handleRef.current);
    };

    function set(fn, delayMs) {
      if (delayMs === void 0) {
        delayMs = 0;
      }

      if (!isMounted()) return;
      clear();

      if (delayMs <= MAX_DELAY_MS) {
        // For simplicity, if the timeout is short, just set a normal timeout.
        handleRef.current = setTimeout(fn, delayMs);
      } else {
        setChainedTimeout(handleRef, fn, Date.now() + delayMs);
      }
    }

    return {
      set: set,
      clear: clear
    };
  }, []);
}

/***/ }),

/***/ 1382:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(1147);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 699:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/default-splash-card.0ded0b20.png","height":1667,"width":1667,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAAqElEQVR42iWOOQrCABBF5wiC4lKIW+GWmEWSVo8QUAhoE21SBtLmDIE0aXOAtDmC1mlyn4cZhAczzPzP/4JhYjs4Lu5Zl5OFeeoRHZMZgyEizBcslmx3/Vs4GjyevN4kCbc7QcDlym4veD5VRdPQddQ1aUoUsVqLGsNQhWVJ2/L5kueIiKatN4iQZRSFXuOY0Vi0lWVrq/0BEWU8xXa01R+1en6PigzzB2D/YcmSCI2wAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 3065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _assets_img_default_splash_card_png__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(699);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);





const baseUrl = "https://www.casperlabs.io/";
const siteName = "Casper Labs";
function CustomHead(param) {
    let { title , description ="" , og , twitter , business , children  } = param;
    if (!og) {
        og = {
            ogTitle: title,
            ogDescription: description,
            ogImage: _assets_img_default_splash_card_png__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src
        };
    }
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const key = (0,react__WEBPACK_IMPORTED_MODULE_4__.useId)();
    const ogUrl = "".concat(baseUrl.substring(0, baseUrl.length - 1)).concat(router.asPath);
    return(// eslint-disable-next-line @next/next/no-script-component-in-head
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/x-icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "192x192",
                href: "/android-chrome-192x192.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "512x512",
                href: "/android-chrome-512x512.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preload",
                href: "".concat(baseUrl, "icons/navbar-toggle-icon.webp"),
                as: "image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                content: "Casper Labs"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "googlebot",
                content: "all"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "bingbot",
                content: "all"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "all"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "facebook-domain-verification",
                content: "5dpoinx6gwzawxktv7aakmzim1f23c"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: siteName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: "1200"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: "630"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: og.ogTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: og.ogDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: ogUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: og.ogImage
            }),
            twitter && Object.keys(twitter).map((p)=>{
                const content = twitter[p];
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:".concat(p),
                    content: content
                }, key + p);
            }),
            business && Object.keys(business).map((p)=>{
                const content = business[p];
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "business:contact_data:".concat(p),
                    content: content
                }, key + p);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: ogUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            children
        ]
    }));
}


/***/ }),

/***/ 4516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Hero; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5005);
/* harmony import */ var _Hero_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5380);
/* harmony import */ var _Hero_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Hero_module_scss__WEBPACK_IMPORTED_MODULE_2__);






function Hero(param) {
    let { halfTitle , title , desc , bgImage , linkButton , linkButton2 , customClass , col1 , col2 , colLg1 , colLg2 , children , childrenCol , isHeader  } = param;
    const componentClass = "Hero position-relative ".concat(customClass !== null && customClass !== void 0 ? customClass : "");
    const childrenContentClass = "childrenContent ".concat((_Hero_module_scss__WEBPACK_IMPORTED_MODULE_2___default().childrenContent));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: componentClass,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: "align-items-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "content",
                    md: col1,
                    lg: colLg1,
                    children: [
                        halfTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "half-title",
                            children: halfTitle
                        }),
                        isHeader ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "header-section-title mb-4",
                            dangerouslySetInnerHTML: {
                                __html: title !== null && title !== void 0 ? title : ""
                            }
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "header-section-title section-title-h2 mb-4",
                            dangerouslySetInnerHTML: {
                                __html: title !== null && title !== void 0 ? title : ""
                            }
                        }),
                        desc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mb-4",
                            children: desc
                        }),
                        childrenCol && childrenCol === 1 && children,
                        linkButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: linkButton.link,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                className: linkButton2 && "me-4 mb-4 mb-lg-0",
                                variant: linkButton.variant,
                                children: linkButton.label
                            })
                        }),
                        linkButton2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: linkButton2.link,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                variant: linkButton2.variant,
                                children: linkButton2.label
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    style: {
                        backgroundImage: bgImage ? 'url("'.concat(bgImage, '")') : "none"
                    },
                    className: childrenContentClass,
                    md: col2,
                    lg: colLg2,
                    children: (!childrenCol || childrenCol === 2) && children
                })
            ]
        })
    });
}


/***/ }),

/***/ 1608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ListLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1555);
/* harmony import */ var react_bootstrap_Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6968);
/* harmony import */ var _ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5973);
/* harmony import */ var _ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1__);




function ListLoader() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_ListLoader_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loaderContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: "mt-5",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                md: "auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Spinner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    className: "text-green",
                    animation: "border",
                    role: "status",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "visually-hidden",
                        children: "Loading..."
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 7654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Newsletter2; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/@shared/components/loaders/ListLoader/ListLoader.tsx
var ListLoader = __webpack_require__(1608);
// EXTERNAL MODULE: ./src/@shared/hooks/useHotspotForm.ts
var useHotspotForm = __webpack_require__(7602);
;// CONCATENATED MODULE: ./src/@shared/components/layout/Modal/HubspotForm.tsx




function HubspotForm(param) {
    let { formId , target , children , onFormSubmitted  } = param;
    const { loading , initHotspotForm , show  } = (0,useHotspotForm/* default */.Z)({
        region: "na1",
        portalId: "6073987",
        formId,
        target,
        autohide: true
    });
    (0,react.useEffect)(()=>{
        const timerHubspot = setTimeout(()=>{
            initHotspotForm();
        }, 1000);
        return ()=>{
            clearTimeout(timerHubspot);
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (onFormSubmitted) onFormSubmitted(show);
    }, [
        onFormSubmitted,
        show
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLoader/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "formContainer",
                children: children
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/@shared/hooks/framerMotion.tsx
var framerMotion = __webpack_require__(658);
// EXTERNAL MODULE: ./src/@shared/components/newsletter/Newsletter2/Newsletter2.module.scss
var Newsletter2_module = __webpack_require__(8877);
var Newsletter2_module_default = /*#__PURE__*/__webpack_require__.n(Newsletter2_module);
;// CONCATENATED MODULE: ./src/@shared/components/newsletter/Newsletter2/Newsletter2.tsx






function Newsletter2(param) {
    let { title , desc , col1 , col2 , customClass  } = param;
    const componentClass = "newsLetter2 ".concat((Newsletter2_module_default()).newsLetter2, " ").concat(customClass !== null && customClass !== void 0 ? customClass : "");
    const [submitted, setSubmitted] = (0,react.useState)(false);
    const onFormSubmitted = (value)=>{
        setSubmitted(value !== null && value !== void 0 ? value : false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: componentClass,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
            y: 100,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: "align-items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            md: col1 ? col1 : 6,
                            className: (Newsletter2_module_default()).title,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "h3 mb-4 mb-lg-0",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-4 mb-lg-0",
                                    children: desc
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            md: col2 ? col2 : 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "position-relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HubspotForm, {
                                    formId: "1f65e0fe-b2be-4ee0-986d-ac8f8821f529",
                                    target: "#getCTANewsletterHubspot",
                                    onFormSubmitted: onFormSubmitted,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: "getCTANewsletterHubspot"
                                        }),
                                        !submitted && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "inputArrow",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "12",
                                                height: "11",
                                                viewBox: "0 0 10 8",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M0.997559 4.00021H9.00205M9.00205 4.00021L5.8578 0.855957M9.00205 4.00021L5.8578 7.14447",
                                                        stroke: "#fff"
                                                    }),
                                                    " "
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
}


/***/ }),

/***/ 6091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EA": function() { return /* binding */ scrollObjFromAnchor; },
/* harmony export */   "rP": function() { return /* binding */ scrollToTargetAdjusted; }
/* harmony export */ });
/* unused harmony exports scrollObjFromBody, scrollObjFromAnchorWithRetry */
const scrollObjFromBody = (el)=>{
    const obj = document.getElementById(el);
    if (obj) {
        obj.scrollIntoView({
            block: "start",
            behavior: "smooth"
        });
    }
};
const scrollToTargetAdjusted = (el, offset)=>{
    const obj = document.getElementById(el);
    if (obj) {
        const elementPosition = obj.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }
};
const scrollObjFromAnchorWithRetry = (route, repeat, offset)=>{
    scrollObjFromAnchor(route, offset);
    for(let index = 1; index < repeat; index++){
        const timer = setTimeout(()=>{
            scrollObjFromAnchor(route, offset);
            if (timer) clearTimeout(timer);
        }, 1000 * index);
    }
};
const scrollObjFromAnchor = (route, offset)=>{
    const splittedRoute = route.split("#");
    if (splittedRoute.length == 2) {
        if (offset) {
            scrollToTargetAdjusted(splittedRoute[1], offset);
        } else {
            scrollObjFromBody(splittedRoute[1]);
        }
    }
};



/***/ }),

/***/ 658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FramerMotion; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3838);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



function FramerMotion(param) {
    let { children , animation ="fadeUp" , y  } = param;
    const [isMobile, setIsMobile] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setIsMobile(window.innerWidth <= 768);
        const handleResize = ()=>{
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    if (isMobile) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: children
    });
    const fadeInProps = {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        }
    };
    const fadeUpProps = {
        initial: {
            opacity: 0,
            y: y && y || 250
        },
        whileInView: {
            opacity: 1,
            y: 0
        },
        transition: {
            type: "spring",
            stiffness: 50,
            duration: 2
        },
        viewport: {
            once: true
        },
        className: "framerMotion"
    };
    const animationProps = animation === "fadeIn" ? fadeInProps : fadeUpProps;
    const { ...motionProps } = animationProps;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
        ...motionProps,
        children: children
    });
}


/***/ }),

/***/ 7602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useHotspotForm; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

const reducer = (currentState, newState)=>{
    return {
        ...currentState,
        ...newState
    };
};
function useHotspotForm(param) {
    let { region , portalId , formId , target , autohide  } = param;
    const initialState = {
        loading: true,
        show: false
    };
    const [{ loading , show  }, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(reducer, initialState);
    const toggleShow = ()=>setState({
            show: !show
        });
    const noShow = ()=>{
        setState({
            show: false
        });
        initHotspotForm();
    };
    const initHotspotForm = ()=>{
        hbspt.forms.create({
            region,
            portalId,
            formId,
            target,
            onFormReady: ()=>{
                setState({
                    loading: false
                });
            },
            onBeforeFormInit: (ctx)=>{
                if (ctx.pageUrl) {
                    setState({
                        loading: false
                    });
                }
            },
            onFormSubmitted: function() {
                setState({
                    show: true
                });
                if (autohide) {
                    const timerHubspot = setTimeout(()=>{
                        noShow();
                    }, 5000);
                    return ()=>{
                        clearTimeout(timerHubspot);
                    };
                }
            }
        });
    };
    return {
        loading,
        show,
        toggleShow,
        noShow,
        initHotspotForm
    };
}


/***/ }),

/***/ 1147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Contact; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
;// CONCATENATED MODULE: ./src/assets/img/contact-us-rectangle.webp
/* harmony default export */ var contact_us_rectangle = ({"src":"/_next/static/media/contact-us-rectangle.239468c1.webp","height":1315,"width":1410,"blurDataURL":"data:image/webp;base64,UklGRmwAAABXRUJQVlA4IGAAAAAwAgCdASoIAAcAAkA4JbACdLoBLfw8ZbOeIAD+9nZz0Pnx9V7xFRxSfP3KUtwBA6q2KAUxHh5jYGky/+fuN+YD7+1H/4fwH/9GcJr/56sn5e979YD7+1H/4fQskGRnUAA=","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/@shared/functions/animations.ts
var animations = __webpack_require__(6091);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/@shared/components/head/customHead/customHead.tsx
var customHead = __webpack_require__(3065);
// EXTERNAL MODULE: ./src/@shared/components/newsletter/Newsletter2/Newsletter2.tsx + 1 modules
var Newsletter2 = __webpack_require__(7654);
// EXTERNAL MODULE: ./src/@shared/components/hero/Hero/Hero.tsx
var Hero = __webpack_require__(4516);
// EXTERNAL MODULE: ./src/@shared/hooks/useHotspotForm.ts
var useHotspotForm = __webpack_require__(7602);
// EXTERNAL MODULE: ./src/@shared/hooks/framerMotion.tsx
var framerMotion = __webpack_require__(658);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Toast.js + 4 modules
var Toast = __webpack_require__(5015);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(5005);
// EXTERNAL MODULE: ./src/@shared/components/loaders/ListLoader/ListLoader.tsx
var ListLoader = __webpack_require__(1608);
;// CONCATENATED MODULE: ./src/modules/contact/components/HotspotContactForm/HotspotContactForm.tsx



function HotspotContactForm(param) {
    let { loading , show , toggleShow  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
            children: [
                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLoader/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "hubspotForm",
                    children: " "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* default */.Z, {
                    show: show,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toast/* default.Body */.Z.Body, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Thank you! We will be in touch with you soon!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "secondary",
                                onClick: toggleShow,
                                children: "Accept"
                            })
                        ]
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./src/modules/contact/components/ContactForm/ContactForm.module.scss
var ContactForm_module = __webpack_require__(6581);
var ContactForm_module_default = /*#__PURE__*/__webpack_require__.n(ContactForm_module);
;// CONCATENATED MODULE: ./src/modules/contact/components/ContactForm/ContactForm.tsx




function ContactForm(param) {
    let { loading , show , toggleShow  } = param;
    const titleClass = "py-6 px-4 pt-lg-6 ".concat((ContactForm_module_default()).titleCol);
    const formClass = "py-4 px-1 px-sm-4 pt-lg-6 px-lg-6 ".concat((ContactForm_module_default()).formCol);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "formContainer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
            className: "flex-row-reverse flex-column-reverse flex-md-row-reverse",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                    md: 6,
                    className: titleClass,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            className: "section-title-h2 mb-4 ".concat((ContactForm_module_default()).padText),
                            children: [
                                "How can we ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-green",
                                    children: "help you?"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (ContactForm_module_default()).padText,
                            children: "Got a technical issue? Want to send feedback about a beta feature? Let us know."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    md: 6,
                    className: formClass,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HotspotContactForm, {
                        loading: loading !== null && loading !== void 0 ? loading : true,
                        show: show !== null && show !== void 0 ? show : false,
                        toggleShow: toggleShow
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/contact.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 











var __N_SSP = true;
function Contact() {
    const { loading , show , toggleShow , initHotspotForm  } = (0,useHotspotForm/* default */.Z)({
        region: "na1",
        portalId: "6073987",
        formId: "3dffe01e-915d-4159-a261-5aa387e33be7",
        target: "#hubspotForm"
    });
    const pageClass = "overflow-hidden contactUsPage";
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const timer = setTimeout(()=>{
            (0,animations/* scrollObjFromAnchor */.EA)(router.asPath, 60);
            if (router.query.section) {
                (0,animations/* scrollToTargetAdjusted */.rP)(router.query.section.toString(), 60);
            }
            initHotspotForm();
        }, 1500);
        return ()=>{
            clearTimeout(timer);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(customHead/* default */.Z, {
                title: "Contact Us & Get Started With Blockchain | Casper Labs",
                description: "Connect with Casper Labs and reach out to our team. Discover how our blockchain ecosystems and expertise can transform your business & create new value.",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    href: contact_us_rectangle.src,
                    as: "image"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                animation: "fadeIn",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: pageClass,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                                isHeader: true,
                                customClass: "contactHero pt-0 pb-0",
                                col1: 6,
                                col2: 6,
                                halfTitle: "Contact us",
                                title: "Let's Move Forward, Together",
                                desc: "Starting the journey towards revenue transformation starts with a single step. Let's talk.",
                                bgImage: contact_us_rectangle.src
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "contactForm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framerMotion/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactForm, {
                                            loading: loading !== null && loading !== void 0 ? loading : true,
                                            show: show !== null && show !== void 0 ? show : false,
                                            toggleShow: toggleShow
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsletter2/* default */.Z, {
                                col1: 5,
                                col2: 7,
                                title: "Sign up for our newsletter!"
                            })
                        ]
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 5380:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"childrenContent":"Hero_childrenContent__hSc1T"};

/***/ }),

/***/ 5973:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"ListLoader_loaderContainer__hS6rF"};

/***/ }),

/***/ 8877:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newsLetter2":"Newsletter2_newsLetter2__S1IQd","form":"Newsletter2_form____nD9","title":"Newsletter2_title__CRAYf","spinner":"Newsletter2_spinner__LNCxl"};

/***/ }),

/***/ 6581:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titleCol":"ContactForm_titleCol__yumUg","formCol":"ContactForm_formCol__uwRR1","padText":"ContactForm_padText__P8sqs"};

/***/ }),

/***/ 5015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Toast; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useTimeout.js
var useTimeout = __webpack_require__(4044);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 3 modules
var Transition = __webpack_require__(6273);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Fade.js
var Fade = __webpack_require__(1068);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ToastFade.js




const fadeStyles = {
  [Transition/* ENTERING */.d0]: 'showing',
  [Transition/* EXITING */.Ix]: 'showing show'
};
const ToastFade = /*#__PURE__*/react.forwardRef((props, ref) => /*#__PURE__*/(0,jsx_runtime.jsx)(Fade/* default */.Z, { ...props,
  ref: ref,
  transitionClasses: fadeStyles
}));
ToastFade.displayName = 'ToastFade';
/* harmony default export */ var esm_ToastFade = (ToastFade);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useEventCallback.js
var useEventCallback = __webpack_require__(8146);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(6792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CloseButton.js
var CloseButton = __webpack_require__(1485);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ToastContext.js

const ToastContext = /*#__PURE__*/react.createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClose() {}

});
/* harmony default export */ var esm_ToastContext = (ToastContext);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ToastHeader.js









const defaultProps = {
  closeLabel: 'Close',
  closeButton: true
};
const ToastHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  closeLabel,
  closeVariant,
  closeButton,
  className,
  children,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'toast-header');
  const context = (0,react.useContext)(esm_ToastContext);
  const handleClick = (0,useEventCallback/* default */.Z)(e => {
    context == null ? void 0 : context.onClose == null ? void 0 : context.onClose(e);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    ...props,
    className: classnames_default()(bsPrefix, className),
    children: [children, closeButton && /*#__PURE__*/(0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
      "aria-label": closeLabel,
      variant: closeVariant,
      onClick: handleClick,
      "data-dismiss": "toast"
    })]
  });
});
ToastHeader.displayName = 'ToastHeader';
ToastHeader.defaultProps = defaultProps;
/* harmony default export */ var esm_ToastHeader = (ToastHeader);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(6611);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/ToastBody.js

/* harmony default export */ var ToastBody = ((0,createWithBsPrefix/* default */.Z)('toast-body'));
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Toast.js










const Toast = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  transition: Transition = esm_ToastFade,
  show = true,
  animation = true,
  delay = 5000,
  autohide = false,
  onClose,
  bg,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'toast'); // We use refs for these, because we don't want to restart the autohide
  // timer in case these values change.

  const delayRef = (0,react.useRef)(delay);
  const onCloseRef = (0,react.useRef)(onClose);
  (0,react.useEffect)(() => {
    delayRef.current = delay;
    onCloseRef.current = onClose;
  }, [delay, onClose]);
  const autohideTimeout = (0,useTimeout/* default */.Z)();
  const autohideToast = !!(autohide && show);
  const autohideFunc = (0,react.useCallback)(() => {
    if (autohideToast) {
      onCloseRef.current == null ? void 0 : onCloseRef.current();
    }
  }, [autohideToast]);
  (0,react.useEffect)(() => {
    // Only reset timer if show or autohide changes.
    autohideTimeout.set(autohideFunc, delayRef.current);
  }, [autohideTimeout, autohideFunc]);
  const toastContext = (0,react.useMemo)(() => ({
    onClose
  }), [onClose]);
  const hasAnimation = !!(Transition && animation);

  const toast = /*#__PURE__*/(0,jsx_runtime.jsx)("div", { ...props,
    ref: ref,
    className: classnames_default()(bsPrefix, className, bg && `bg-${bg}`, !hasAnimation && (show ? 'show' : 'hide')),
    role: "alert",
    "aria-live": "assertive",
    "aria-atomic": "true"
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_ToastContext.Provider, {
    value: toastContext,
    children: hasAnimation && Transition ? /*#__PURE__*/(0,jsx_runtime.jsx)(Transition, {
      in: show,
      unmountOnExit: true,
      children: toast
    }) : toast
  });
});
Toast.displayName = 'Toast';
/* harmony default export */ var esm_Toast = (Object.assign(Toast, {
  Body: ToastBody,
  Header: esm_ToastHeader
}));

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [437,774,888,179], function() { return __webpack_exec__(1382); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);